import { Component, type ErrorInfo, type ReactNode } from 'react';
import i18n from '../i18n';

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  error: Error | null;
}

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Frontend render failed', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <main className="grid min-h-screen place-items-center bg-background px-5 text-foreground">
          <div className="max-w-xl rounded-lg border border-border bg-surface p-6 text-surface-foreground">
            <p className="text-sm font-semibold uppercase tracking-wide text-destructive">{i18n.t('errorBoundary.eyebrow')}</p>
            <h1 className="mt-3 text-2xl font-heading font-semibold tracking-normal text-foreground">{i18n.t('errorBoundary.title')}</h1>
            <p className="mt-3 text-sm text-muted-foreground">{this.state.error.message}</p>
            <code className="mt-4 block rounded bg-muted p-4 text-sm text-destructive">
              {this.state.error.stack}
            </code>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}
